import { SafetyCertificateOutlined } from '@ant-design/icons';
import { Button, Input, Modal } from 'antd';
import { useRevokeHipaaMutation } from 'api/HipaaApi';
import HipaaStatusTag from 'components/Account/HipaaStatusTag/HipaaStatusTag';
import { useState } from 'react';
import { BsFillShieldSlashFill } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import { selectAuthUser } from 'store/authSlice';
import { closeModal, selectModalName } from 'store/modalSlice';
import { useAppDispatch } from 'store/store';
import { securityLogger } from 'utils/securityLogger';
import './HipaaRevokeModal.css';

export const HIPAA_REVOKE_MODAL_NAME = 'HIPAA_REVOKE_MODAL_NAME';

function HipaaRevokeModal() {
  const dispatch = useAppDispatch();
  const user = useSelector(selectAuthUser);
  const [revokeHipaa, { isLoading: isRevoking }] = useRevokeHipaaMutation();

  const [confirmText, setConfirmText] = useState('');

  const isConfirmed = confirmText.toUpperCase() === 'REVOKE';

  const handleRevoke = async () => {
    if (!isConfirmed) return;
    try {
      await revokeHipaa().unwrap();
      dispatch(closeModal());
    } catch (e: any) {
      securityLogger.error('Failed to revoke HIPAA authorization', e);
    }
  };

  const handleCancel = () => {
    dispatch(closeModal());
  };

  return (
    <Modal open={true} footer={null} onCancel={handleCancel} width={500} centered className="hipaa-revoke-modal">
      <div className="hipaa-modal-container">
        <div className="hipaa-shield-icon">
          <SafetyCertificateOutlined />
        </div>

        <h3 className="hipaa-modal-title">HIPAA Authorization Status</h3>

        <div className="hipaa-status-tag-container">
          <HipaaStatusTag status={user?.hipaaStatus} />
        </div>

        <p className="hipaa-description">
          You have authorized Eternal Applications, Inc. to store your messages and deliver them to your designated
          recipients under HIPAA guidelines.
        </p>

        <div className="hipaa-revoke-warning-block">
          <p className="warning-title">Revoking your authorization will initiate permanent account deletion.</p>
          <p className="warning-description">
            All of your messages, recipient information, and stored content will be permanently removed and cannot be
            recovered.
          </p>
        </div>

        <div className="hipaa-confirm-input-block">
          <div className="input-label">
            Type <span className="highlight">REVOKE</span> to initiate account deletion
          </div>
          <Input placeholder="REVOKE" value={confirmText} onChange={(e) => setConfirmText(e.target.value)} />
        </div>

        <Button
          type="primary"
          danger
          size="large"
          block
          loading={isRevoking}
          disabled={!isConfirmed}
          onClick={handleRevoke}
          icon={<BsFillShieldSlashFill />}
        >
          Revoke Authorization & Delete Account
        </Button>
      </div>
    </Modal>
  );
}

function HipaaRevokeModalWrapper() {
  const modalName = useSelector(selectModalName);

  return modalName === HIPAA_REVOKE_MODAL_NAME ? <HipaaRevokeModal /> : null;
}

export default HipaaRevokeModalWrapper;
